import { Controller } from '@hotwired/stimulus'
import ApexCharts from 'apexcharts'

export default class extends Controller {
  static values = { options: Object }

  static FUNCTION_KEYS = ['formatter', 'custom']

  // recursively iterate through JSON object to convert string definitions to functions
  stringToFunc(obj) {
    if (typeof obj !== 'object' || obj === null) return

    for (const key of this.constructor.FUNCTION_KEYS) {
      if (key in obj && typeof obj[key] === 'string') {
        obj[key] = new Function('return ' + obj[key])()
      }
    }
    for (const key in obj) {
      this.stringToFunc(obj[key])
    }
  }

  connect() {
    const options = this.optionsValue
    this.stringToFunc(options)
    this.chart = new ApexCharts(this.element, options)
    this.chart.render()
  }

  disconnect() {
    this.chart.destroy()
  }
}
